import AssetsSpinner from '@jira/assets-app__spinner/src/SpinnerView.tsx';
import { MenuIdPeople } from '@jira/navigation-apps__constants/src/MenuIdPeople.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServicedeskPageContextResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { assetsReportsTemplateRoute } from '@jira/router-routes__assets-app-routes/src/assetsReportsTemplateRoute.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { toPackageName, APP_NAMES } from '@jira/servicedesk__common/src/toPackageName.tsx';
import {
	AssetsReports,
	LazyServicedeskCmdbAssetsReports,
} from '@jira/router-routes__servicedesk-cmdb-entries/src/ui/reports/index.tsx';
import { getAssetsAppResources } from '@jira/router-routes__servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import {
	LazyAssetsLayout,
	AssetsLayout,
} from '@jira/assets-app__layout/src/LayoutAssetsLayout.tsx';
import { AssetsPageConfigContainer } from '@jira/assets-app__page-config-container/src/AssetsPageConfigContainer.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const assetsReportsTemplateRouteEntry: Route = createEntry(
	assetsReportsTemplateRoute,
	() => ({
		group: 'assets',
		LayoutOverrideComponent: AssetsLayout,
		PageConfigContainerOverride: AssetsPageConfigContainer,
		skeleton: AssetsSpinner,
		// eslint-disable-next-line no-restricted-syntax
		component: AssetsReports,
		resources: [...getAssetsAppResources(), ...getServicedeskPageContextResources()],
		forPaint: [LazyAssetsLayout, LazyServicedeskCmdbAssetsReports],
		navigation: {
			menuId: MenuIdPeople,
		},
		meta: {
			reporting: {
				id: APP_NAMES.INSIGHT_ASSETS_REPORTS,
				packageName: toPackageName(APP_NAMES.INSIGHT_ASSETS_REPORTS),
				teamName: 'ITSM SAGA',
			},
		},
		perfMetricKey: 'service-management.insight-cmdb.load-assets-reports-template',
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
